export const ItemType = Object.freeze({
  INVESTMENT_STRATEGY: 'INVESTMENT_STRATEGY',
  INVESTMENT_STRATEGY_REVIEW: 'INVESTMENT_STRATEGY_REVIEW',
  RENT_RELIEF: 'RENT_RELIEF',
  PENSION_ESTABLISHMENT: 'PENSION_ESTABLISHMENT',
  PENSION_PAYMENT_INSTRUCTION: 'PENSION_PAYMENT_INSTRUCTION',
});

export const ItemTypeFormatted = Object.freeze({
  INVESTMENT_STRATEGY: 'Investment Strategy',
  INVESTMENT_STRATEGY_REVIEW: 'Investment Strategy Review',
  RENT_RELIEF: 'COVID-19 Rent Relief',
  PENSION_ESTABLISHMENT: 'Pension Establishment',
  PENSION_PAYMENT_INSTRUCTION: 'Pension Payment Instruction',
});

export const ShareableItemType = Object.freeze({
  INVESTMENT_STRATEGY: 'Investment Strategy',
  INVESTMENT_STRATEGY_REVIEW: 'Investment Strategy Review',
  COVID: 'Covid-19 Rent Relief',
  PENSION_ESTABLISHMENT: 'Pension Establishment',
  PENSION_PAYMENT_INSTRUCTION: 'Benefit Payment Instruction',
});

export default ItemType;
